import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.4 4.8a1 1 0 0 1 1-1h19.2a1 1 0 1 1 0 2H2.4a1 1 0 0 1-1-1Zm0 7.2a1 1 0 0 1 1-1h19.2a1 1 0 1 1 0 2H2.4a1 1 0 0 1-1-1Zm0 7.2a1 1 0 0 1 1-1h19.2a1 1 0 1 1 0 2H2.4a1 1 0 0 1-1-1Z"
  />,
  'Menu1'
)
